import Vue from 'vue'
import Vuex from 'vuex'
import VuePersist from 'vuex-persist'
Vue.use(Vuex)
const vuexSession = new VuePersist({
  storage: window.sessionStorage
})
const state = {
  navInde: 0,
  swiperIndex: 0,
  homeIndex: 0,
  benefitIndex: 0,
  myorderIndex: 0,
  myorderSindex: 0,
  showDown: 0,
  myorder: false,
  list: false,
  goOut: false,
  cart: false,
  agentInfo: null,
  useEntertime: null,
  useEnteruid: null,
  orderPoint:'',
  orderPaytype:'',
  orderOkInfo: null,
  YaoqingSuid:''
}
const getters = {}
const mutations = {
  saveNavIndex (state, roslov) {
    state.navInde = roslov
  },
  saveSwiperIndex (state, res) {
    state.swiperIndex = res
  },
  savehomeIndex (state, res) {
    state.homeIndex = res
  },
  saveBenefitIndex (state, res) {
    state.benefitIndex = res
  },
  savemyorderIndex (state, res) {
    state.myorderIndex = res
  },
  savemyorderSindex (state, res) {
    state.myorderSindex = res
  },
  savemyorder (state, res) {
    state.myorder = res
  },
  savelist (state, res) {
    state.list = res
  },
  savegoOut (state, res) {
    state.goOut = res
  },
  savecart (state, res) {
    state.cart = res
  },
  saveshowDown (state, res) {
    state.showDown = res
  },
  saveagentInfo (state, res) {
    state.agentInfo = res
  },
  saveuseEntertime (state, res) {
    state.useEntertime = res
  },
  saveuseEnteruid (state, res) {
  state.useEnteruid = res
 },
  saveorderPoint (state, res) {
    state.orderPoint = res
  },
  saveorderPaytype (state, res) {
    state.orderPaytype = res
  },
  saveorderOkInfo (state, res) {
    state.orderOkInfo = res
  },
  saveYaoqingSuid (state, res) {
    state.YaoqingSuid = res
  }
}
const store = new Vuex.Store({
  state,
  getters,
  mutations,
  plugins: [vuexSession.plugin]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js